var buttons = document.querySelectorAll(".button");
Array.prototype.forEach.call(buttons, function (el, i) {
  if (el.getAttribute("disabled") !== null || el.classList.contains("button--disabled")) {
    el.addEventListener("click", function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
    });
  }
});
